import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const TennisColored = ({ size = 'xsmall' }: IconProps) => {
    return (
        <svg width={IconSizes[size]} height={IconSizes[size]} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g id="Tennis" fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="M19.778 19.778c-4.296 4.296-11.26 4.296-15.556 0-4.296-4.296-4.296-11.26 0-15.556 4.296-4.296 11.26-4.296 15.556 0 4.296 4.296 4.296 11.26 0 15.556z"
                    fill="#D7FF38"
                />
                <path
                    d="M18.367 18.364a8.94 8.94 0 0 1-6.297 2.632.19.19 0 0 1 .001-.082c.08-.422.89-1.389 2.723-2.193.92-.403 1.711-.933 2.354-1.576a7.282 7.282 0 0 0 0-10.29 7.29 7.29 0 0 0-10.295 0c-.86.859-1.366 1.865-1.592 2.388-.774 1.797-1.861 2.896-2.25 2.977a8.97 8.97 0 0 1 2.622-6.584A8.95 8.95 0 0 1 12.001 3c2.405 0 4.666.936 6.366 2.636 3.51 3.509 3.51 9.219 0 12.728M3.282 14.197c.018-.003.037 0 .056-.004 1.586-.304 3.017-2.431 3.762-4.16.135-.315.52-1.117 1.167-1.764a5.287 5.287 0 0 1 7.467 0 5.28 5.28 0 0 1 0 7.462c-.472.472-1.044.851-1.743 1.158-2.183.956-3.636 2.323-3.886 3.655-.016.084-.01.165-.017.247a8.941 8.941 0 0 1-6.806-6.594m16.5-9.975A10.931 10.931 0 0 0 12 1c-2.94 0-5.704 1.144-7.783 3.222-4.29 4.288-4.29 11.267 0 15.556A10.936 10.936 0 0 0 12.001 23c2.94 0 5.703-1.144 7.78-3.222 4.292-4.289 4.292-11.268 0-15.556"
                    fill="#0D0E0F"
                />
            </g>
        </svg>
    );
};
